import * as z from 'zod';
import { SuretyQuoteStatus } from '../../../../enums.mjs';
import { companyContactId, percentSchemaV2, rateSchemaV2, carrierName, userId } from '../../../../types/opaque.mjs';
import { Create } from '../../../surety/quote/surety-quote.dto.mjs';
import { Contract } from './contract/contract-surety-quote.dto.mjs';

var SuretyQuote;
(function (SuretyQuote) {
    (function (UpdateStatus) {
        (function (Request) {
            Request.schema = z.discriminatedUnion("suretyType", [
                Contract.UpdateStatus.Request.schema,
            ]);
        })(UpdateStatus.Request || (UpdateStatus.Request = {}));
    })(SuretyQuote.UpdateStatus || (SuretyQuote.UpdateStatus = {}));
    (function (Update) {
        (function (Request) {
            Request.schema = z.discriminatedUnion("suretyType", [Contract.Update.Request.schema]);
        })(Update.Request || (Update.Request = {}));
    })(SuretyQuote.Update || (SuretyQuote.Update = {}));
    (function (Create$1) {
        (function (Request) {
            Request.quoteSchema = Create.Request.quoteSchema;
            const adminProjectSchema = Create.projectSchema.extend({
                monthsToComplete: Create.projectSchema.shape.monthsToComplete.meta({
                    partial: true,
                    requiredForApproval: true,
                    label: "Months to complete",
                }),
                contractWarrantyMonths: Create.projectSchema.shape.contractWarrantyMonths.meta({
                    partial: true,
                    requiredForApproval: true,
                    label: "Warranty period",
                }),
                scopeOfWork: Create.projectSchema.shape.scopeOfWork.meta({
                    partial: true,
                    requiredForApproval: true,
                    label: "Scope of work",
                }),
            });
            Request.adminBidQuoteSchema = Create.bidQuoteCreateSchema
                .omit({ project: true, bidDate: true })
                .extend({
                project: adminProjectSchema,
                bidDate: Create.bidQuoteCreateSchema.shape.bidDate.meta({
                    partial: true,
                    requiredForApproval: true,
                    label: "Bid Date",
                }),
                tListingRequired: Create.bidQuoteCreateSchema.shape.tListingRequired.meta({
                    partial: true,
                    requiredForApproval: true,
                    label: "Treasury Listing Required",
                }),
                completionBond: Create.bidQuoteCreateSchema.shape.completionBond.meta({
                    partial: true,
                    requiredForApproval: true,
                    label: "Completion Bond",
                }),
            });
            Request.adminFinalQuoteSchema = Create.finalQuoteCreateSchema
                .omit({ project: true })
                .extend({ project: adminProjectSchema });
            Request.adminBidToFinalQuoteSchema = Create.bidToFinalCreateSchema.extend({
                project: adminProjectSchema,
            });
            const accountCreationPrincipal = z.object({
                id: companyContactId.nullish(),
                name: z.string(),
            });
            Request.adminBidQuoteSchemaForAccountCreation = Request.adminBidQuoteSchema
                .omit({ principal: true })
                .extend({ principal: accountCreationPrincipal });
            Request.adminFinalQuoteSchemaForAccountCreation = Request.adminFinalQuoteSchema
                .omit({ principal: true })
                .extend({ principal: accountCreationPrincipal });
            Request.adminBidToFinalQuoteSchemaForAccountCreation = Request.adminBidToFinalQuoteSchema
                .omit({ principal: true })
                .extend({ principal: accountCreationPrincipal });
            Request.quoteSchemaForAccountCreation = z.discriminatedUnion("contractSuretyType", [
                Request.adminBidQuoteSchemaForAccountCreation,
                Request.adminFinalQuoteSchemaForAccountCreation,
                Request.adminBidToFinalQuoteSchemaForAccountCreation,
            ]);
            const bondTermsApprovedSchema = z.object({
                status: z.literal(SuretyQuoteStatus.approved),
                carrierName: carrierName,
                rate: rateSchemaV2,
                agencyCommissionPercentage: percentSchemaV2,
            });
            const bondTermsDeclinedSchema = z.object({
                status: z.literal(SuretyQuoteStatus.declined),
            });
            Request.bondTermsSchema = z.discriminatedUnion("status", [
                bondTermsApprovedSchema,
                bondTermsDeclinedSchema,
            ]);
            Request.optionalBondTermsSchema = z.preprocess((val) => val && typeof val === "object" && "status" in val && val.status ? val : undefined, Request.bondTermsSchema.optional());
            Request.adminQuoteSchema = z.discriminatedUnion("contractSuretyType", [
                Request.adminBidQuoteSchema,
                Request.adminFinalQuoteSchema,
                Request.adminBidToFinalQuoteSchema,
            ]);
            Request.schema = z.object({
                agentId: userId,
                quote: Request.adminQuoteSchema,
                bondTerms: Request.optionalBondTermsSchema,
            });
        })(Create$1.Request || (Create$1.Request = {}));
    })(SuretyQuote.Create || (SuretyQuote.Create = {}));
    SuretyQuote.Contract = Contract;
})(SuretyQuote || (SuretyQuote = {}));

export { SuretyQuote };
